import { Space, SpaceVertical } from '@looker/components';
import { DsRadio, DsRadioGroup, DsTypography } from '@pulsepointinc/design-system-react';
import { type FC, useEffect, useId, useState } from 'react';
import { useFilters } from '../../../../../../../hooks/useFilters';
import type { Filter } from '../../../../../../../stores/filters';
import useFilterSuggestions from '../../../../hooks/useFilterSuggestions';

interface PrescribingBehaviorTypeProps {
  onMultiFilterChange?: (filter: Filter) => void;
}

const filterName = 'prescribing_behavior_prescription_type_filter';

const PrescribingBehaviorType: FC<PrescribingBehaviorTypeProps> = ({ onMultiFilterChange }) => {
  const radioGroupId = useId();
  const { filters } = useFilters();
  const filterExpression = filters[filterName]?.expression ?? '';
  const { suggestions = [], defaultFilterValue } = useFilterSuggestions(filterName);

  const toggleOptions = suggestions;

  const [selectedOption, setSelectedOption] = useState<string>(filterExpression || defaultFilterValue);

  const defaultFilter: Filter = {
    filterName,
    expression: selectedOption,
    enabled: true,
    expressionType: 'target',
  };

  useEffect(() => {
    if (onMultiFilterChange) {
      const filterToSend = {
        ...defaultFilter,
        expression: selectedOption,
      };
      onMultiFilterChange(filterToSend);
    }
  }, []);

  useEffect(() => {
    if (filterExpression) {
      setSelectedOption(filterExpression);
    }
  }, [filterExpression]);

  const handleRadioChange = (value: string) => {
    setSelectedOption(value);

    const filter: Filter = {
      filterName,
      expression: value,
      enabled: true,
      expressionType: defaultFilter.expressionType,
    };

    if (onMultiFilterChange) {
      onMultiFilterChange(filter);
    }
  };

  return (
    <SpaceVertical gap="u2" paddingX="u6">
      <Space gap="u4" align="center">
        <DsTypography variant="label">Type</DsTypography>
        <DsRadioGroup
          name={radioGroupId}
          orientation="horizontal"
          value={selectedOption}
          onValueChange={(e) => handleRadioChange(e.detail as string)}
        >
          {toggleOptions.map((option: string) => (
            <DsRadio key={option} name={radioGroupId} label={option} value={option} />
          ))}
        </DsRadioGroup>
      </Space>
    </SpaceVertical>
  );
};

export default PrescribingBehaviorType;
